import { useMutation, useQueryClient } from 'react-query';

import { deleteUserPage as remove } from 'api/users/deleteUserPage';

const useDeleteUserPage = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: deleteUserPage,
    isLoading,
  } = useMutation(remove, {
    onSuccess: () => {
      queryClient.invalidateQueries('UsersPageData');
    },
  });

  return {
    isSuccess,
    deleteUserPage,
    isLoading,
  };
};

export default useDeleteUserPage;
